import { Box } from "@mui/material";
import React from "react";

const Matrix = ({ size, displaySpread, getCard }: { size: number, displaySpread: boolean, getCard: (index: number) => React.ReactNode }) => {
    const length = size * size;
    return (
        <Box sx={{
            display: displaySpread ? 'grid' : 'none',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 1,
            padding: "5px",
            width: '100%',
            height: '100%',
            margin: '0 auto',
            overflow: 'hidden'
        }}>
            {Array.from({ length: length }, (_, index) => (
                <React.Fragment key={`grid-item-${index}`}>
                    {getCard(index)}
                </React.Fragment>
            ))}
        </Box>
    )
}

export default Matrix;